module.exports = __webpack_public_path__ + "static/img/pic_uavjcjs.3149ec18.png";